import { Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-start-survey-using-group-filter',
  templateUrl: './start-survey-using-group-filter.component.html',
  styleUrls: ['./start-survey-using-group-filter.component.scss']
})
export class StartSurveyUsingGroupFilterComponent implements OnInit, IDialogView {
  data: DialogModel;
  groupFilterKey: string;
  constructor() { }

  ngOnInit() {
  }

  onOkClicked(): boolean {
    if(this.data && this.data.input)
    {
      this.data.input.groupFilterKey = this.groupFilterKey;
    }
    return true;
  }

}
